require('./pricing.scss');
require('src/interlock/no-ui/drawer/no-adhesion-overlap');
require('src/interlock/ui/zipcode-changer/zipcode-changer');

var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var ppMultiLeadForm = require('src/creative/pricing-lead-form/pricing-lead-form');
var vehicle = window.EDM.PageValues.vehicle;
var page = window.EDM.PageValues.page;


// Tracking
var savingRetrieval = window.EDMDataStorage.pricingModuleSavingRetrieval;
if(savingRetrieval) {
    savingRetrieval.event_data.action_category = 'user';
    savingRetrieval.event_data.action_cause = 'page_load';
    savingRetrieval.ads = {
        disable_refresh: true
    };
    eventToolbox.fireAction(savingRetrieval);
}

function processOpts(installedOptions){
    var optString = '';
    if(installedOptions){
        for(var i = 0; i < installedOptions.length; i++){
            optString = optString + installedOptions[i].id;
            if(i < installedOptions.length - 1){
                optString = optString +',';
            }
        }
    }
    return optString;
}

function _clickHandler(e) {
    var $el = $(this);
    var dataEle = $el.closest('#edm-entry-pricing .card-view-price-now');
    var linkClickData = dataEle.data('link-click');
    var modalEle = $($el.attr('data-target'));
    modalEle.modal('show');
    var payLoad = dataEle.data('pricingConfig');
    payLoad.pricingCategory = payLoad.category;
    payLoad.category = undefined;
    payLoad.estimatedSavings = dataEle.data('estimatedSavings');
    var params = {
        make:vehicle.make.niceName,
        model:vehicle.model.niceName,
        year:vehicle.modelYear.year,
        styleId: payLoad.styleId,
        leadSource: 'core',
        callToAction:'purchaseOffer',
        range:50,
        submodel:payLoad.subModels[0],
        trim:payLoad.trim,
        buildData:((payLoad.installedOptions && payLoad.installedOptions.length > 0)?true:false),
        optIds:processOpts(payLoad.installedOptions),
        pageName: page.name,
        pageCat: page.category,
        zipcode: window.EDM.PageValues.region.zipCode
    };
    $('.lead-form-pricing-drawer').one('shown.bs.modal', function(){
        ppMultiLeadForm.loadLeadForm(payLoad, params);
    });
    if(linkClickData) {
        linkClickData.event_category = 'user';
        $.extend(linkClickData.event_data, {
            'creative_id': 'edm-entry-pricing',
            'action_cause': 'button_click'
        });
        eventToolbox.fireAction(linkClickData);
    }
    e.stopPropagation();
}



$('#edm-entry-pricing .card-view-price-now').on('click', _clickHandler);
$('#edm-entry-pricing .btn.view-price-now').on('click', _clickHandler);



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/pricing/pricing.js
// module id = 161
// module chunks = 0 1 16